module.exports = __webpack_public_path__ + "media/career/live_and_work_in_Berlin-d8bb866e.webp";